import React, { useState } from 'react';
import { User, Agency } from '@/types';

import AppModal from '@/components/AppModal';
import AppBox from '@/components/AppBox';
import AppButton from '@/components/AppButton';
import AppAutocomplete from '@/components/AppAutocomplete';

interface AddUserToAgencyModalProps {
  agency: Agency;
  users: User[];
  onClose: () => void;
  onSave: (user: User) => void;
  isOpen: boolean;
}

const AddUserToAgencyModal: React.FC<AddUserToAgencyModalProps> = ({
  agency,
  users,
  onClose,
  onSave,
  isOpen
}) => {
  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  const handleSave = () => {
    if (selectedUser) {
      onSave(selectedUser);
      setSelectedUser(null);
    }
  };

  return (
    <AppModal
      isOpen={isOpen}
      title={`Add User to ${agency.name}`}
      onClose={onClose}
    >
      <AppBox column gap={4}>
        <AppAutocomplete
          options={users}
          value={selectedUser}
          onChange={setSelectedUser}
          placeholder="Search users..."
        />
        
        <AppBox gap={2} justify="end">
          <AppButton variant="outlined" onClick={onClose}>
            Cancel
          </AppButton>
          <AppButton
            onClick={handleSave}
            disabled={!selectedUser}
          >
            Add User
          </AppButton>
        </AppBox>
      </AppBox>
    </AppModal>
  );
};

export default AddUserToAgencyModal; 